/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SkippedCustomerDtoModel, SkippedCustomerDtoModelType } from "./SkippedCustomerDtoModel"
import { SkippedCustomerDtoModelSelector } from "./SkippedCustomerDtoModel.base"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  createdOrders: IObservableArray<VisitDtoModelType>;
}

/**
 * CreateOrdersFromCustomersResultDtoBase
 * auto generated base class for the model CreateOrdersFromCustomersResultDtoModel.
 */
export const CreateOrdersFromCustomersResultDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('CreateOrdersFromCustomersResultDto')
  .props({
    __typename: types.optional(types.literal("CreateOrdersFromCustomersResultDto"), "CreateOrdersFromCustomersResultDto"),
    createdOrders: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => VisitDtoModel)))),
    skippedCustomers: types.union(types.undefined, types.array(types.late((): any => SkippedCustomerDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class CreateOrdersFromCustomersResultDtoModelSelector extends QueryBuilder {
  createdOrders(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`createdOrders`, VisitDtoModelSelector, builder) }
  skippedCustomers(builder: string | SkippedCustomerDtoModelSelector | ((selector: SkippedCustomerDtoModelSelector) => SkippedCustomerDtoModelSelector) | undefined) { return this.__child(`skippedCustomers`, SkippedCustomerDtoModelSelector, builder) }
}
export function selectFromCreateOrdersFromCustomersResultDto() {
  return new CreateOrdersFromCustomersResultDtoModelSelector()
}

export const createOrdersFromCustomersResultDtoModelPrimitives = selectFromCreateOrdersFromCustomersResultDto()
